import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from "react-redux";
import { pexios, toast, uploadImages, validate } from "../../utils/functions";
import { url, history, latinAlphabet } from "../../utils/variables";
import ExpertImage from "../../components/expert/ExpertImage";
import ImagePickerModal from "../../components/master/ImagePickerModal";
import Modal from "../../components/master/Modal";

import ShowPlate from './ShowPlate';
import ImageZoom from '../../components/master/ImageZoom';
import { useTranslation } from 'react-i18next';
import addImage from '../../assets/images/AddImagePlaceholder/addImage.png'

export default function ExpertImages() {
    const { t } = useTranslation();
    const form = useRef(null);
    const [attachments, setAttachments] = useState([]);
    const [lossesArray, setLossesArray] = useState([]);
    const [imageUID, setImageUID] = useState(null);
    const [step, setStep] = useState(1);
    ///
    const [type, setType] = useState('car')
    const [ culpritPlate , setculpritPlate ] = useState([])
    const {user} = useSelector(store => store)
    const { id } = useSelector(store => store.routerData);
    const [culprit,setCulprit] = useState([])

    useEffect(() => {
        pexios('/api/v2/get_accident', 'post', {accident_id: id, type: 'culprit'})
        .then(res=>{
            const {culprit} = res.data.data;
            setCulprit(culprit)
        })
    },[id])

    useEffect(() => {
        pexios('/api/v2/get_accident', 'post', { accident_id: id , type : 'expert_image' })
            .then(res => {
                const { attachments, losses , culprit } = res.data.data;
                setAttachments(attachments);
                setLossesArray(losses);
    
                setculpritPlate(culprit.car);
            });
    }, [id]);

    function finishUpload(image, name, done) {
        uploadImages({
            id,
            type: 'accident',
            name,
            image,
            done,
            callback: (data) => {
                setAttachments(prevState => ([
                    ...prevState,
                    data,
                ]));
            },
        });
    }
    ////
    function stepHandler(step, type) {
        setStep(step)
        setType(type)
    }
    // function imgSort(index) {
    //     const allCrashImg = attachments.filter(img => img.filename.includes(`expert_crash_image_los_x${index+1}x_`))
    //     //allCrashImg.map(img=>img.filename).sort()
    //     const lastIndex = allCrashImg.map(img=>{
    //         const imgArr = img.filename.split("_")
    //         return parseInt(imgArr[imgArr.length-1])
    //     })
    //     console.log(lastIndex)
    //     return attachments.filter(img => img.filename.includes(`expert_crash_image_los_x${index+1}x_`)).length + 1
    // }
    function changeStep() {
        const error = validate(form);
        if (error) {
            // toast(`فیلد های اجباری ${error} را پر کنید.`, 'error');
            toast(t('Complete required fields',{err:error}), 'error');
            return;
        }
        setType('accessories')
    }
    function NextStep() {
        let insuranceId
        if(lossesArray.length)
            insuranceId = culprit.car?.third?.insurance_company
        else 
            insuranceId = culprit.car?.body?.insurance_company
        user.id === 333 && (insuranceId === 25 || insuranceId === 2) ? history.push('/final-images') : history.push('/final-pricing')
    }

    return (
        <div className='content details expert-images'>
            {
                step === 1 && type === 'car' &&
                <>
                    <h4>{`${t('Car image')} ${t('Culprit')}`}</h4>
                    <div className='plate-container'>
                        <ShowPlate plate={culpritPlate}/>
                    </div>
                    <div className='gridParent' ref={form}>
                        <ExpertImage
                            title={`${t('Engraved chassis number')} ${t('Culprit')}`}
                            src={attachments.filter(itm => itm.filename.includes('culprit_chassis_number'))}
                            upload={(img, done) => finishUpload(img, 'expert_culprit_chassis_number', done)}
                            label='chassis_number'
                            // required={!(lossesArray.length > 0 && culpritPlate.has_coroukie === 1)}
                        />
                        <ExpertImage
                            title={`${t('Front car')} ${t('Culprit')}`}
                            src={attachments.filter(itm => itm.filename.includes('culprit_front_image'))}
                            upload={(img, done) => finishUpload(img, 'expert_culprit_front_image', done)}
                            label='front_image'
                            // required={!(lossesArray.length > 0 && culpritPlate.has_coroukie === 1)}
                        />
                        <ExpertImage
                            title={`${t('Back car')} ${t('Culprit')}`}
                            src={attachments.filter(itm => itm.filename.includes('culprit_back_image'))}
                            upload={(img, done) => finishUpload(img, 'expert_culprit_back_image', done)}
                            label='back_image'
                            // required={!(lossesArray.length > 0 && culpritPlate.has_coroukie === 1)}
                        />
                        <ExpertImage
                            title={`${t('Left side car')} ${t('Culprit')}`}
                            src={attachments.filter(itm => itm.filename.includes('culprit_left_image'))}
                            upload={(img, done) => finishUpload(img, 'expert_culprit_left_image', done)}
                            label='left_image'
                            // required={!(lossesArray.length > 0 && culpritPlate.has_coroukie === 1)}
                        />
                        <ExpertImage
                            title={`${t('Right side car')} ${t('Culprit')}`}
                            src={attachments.filter(itm => itm.filename.includes('culprit_right_image'))}
                            upload={(img, done) => finishUpload(img, 'expert_culprit_right_image', done)}
                            label='right_image'
                            // required={!(lossesArray.length > 0 && culpritPlate.has_coroukie === 1)}
                        />
                    </div>
                    <div className='d-flex mt20 pr5 pl5'>
                        <button
                            onClick={changeStep}
                            className='btn btn-white-purple btn-block btn-circle'
                        >
                            {t('Next step')}
                        </button>
                    </div>
                </>
            }
            {
                step === 1 && type === 'accessories' &&
                <>
                    <Modal visible={imageUID}>
                        <div className='image-modal'>
                            <i className='fas fa-times'
                                onClick={() => setImageUID(null)}
                            />
                            {/* <img src={`${url}/files?uid=${imageUID}`} alt='img' /> */}
                            <ImageZoom imgUid={imageUID}/>
                        </div>
                    </Modal>
                    <div className='gridParent'>
                        <div className='crashGrid'>
                            <h4>{`${t('Damaged positions and parts')} ${t('Culprit')}`}</h4>
                            <div className='plate-container'>
                                <ShowPlate plate={culpritPlate}/>
                            </div>
                            <div className='crashGridChild'>
                                {
                                    attachments
                                        .filter(img => (img.filename.includes('crash_image_cul')))
                                        .map((img) => (
                                            <div className='imageBox' key={img.id}>
                                                <img
                                                    src={`${url}/files?uid=${img.uid}&width=150&height=150`}
                                                    alt='img'
                                                    className='img'
                                                    onClick={() => setImageUID(img.uid)}
                                                />
                                            </div>
                                        ))
                                }
                                {
                                    attachments
                                        .filter(img => (img.filename.includes('expert_crash_image_cul')))
                                        .map((img) => (
                                            <div className='imageBox' key={img.id}>
                                                <img
                                                    src={`${url}/files?uid=${img.uid}&width=150&height=150`}
                                                    alt='img'
                                                    className='img'
                                                    onClick={() => setImageUID(img.uid)}
                                                />
                                            </div>
                                        ))
                                }
                                <div className='imageBox'>
                                    <ImagePickerModal
                                        renderBtn={
                                            <div className='add-image'><img src={addImage} alt='img'/></div>
                                            // <div className='defaultImage' data-content={t('Add')}/>
                                        }
                                        disableGallery
                                        upload={(img, done) => finishUpload(
                                            img,
                                            `expert_crash_image_cul${attachments.filter(img => img.filename.includes('expert_crash_image_cul')).length + 1}`,
                                            done
                                        )}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='d-flex mt20 pr5 pl5'>
                        <button
                            onClick={() => setType('car')}
                            className='btn btn-orange btn-block btn-circle-left'
                        >
                            {t('Prev step')}
                        </button>
                        <button
                            onClick={() => lossesArray.length ? stepHandler(2, 'car') : NextStep()}
                            className='btn btn-white-purple btn-block btn-circle-right'
                        >
                            {t('Next step')}
                        </button>
                    </div>
                </>
            }
            {
                step > 1 &&
                lossesArray.map((losses, index) => (

                    <div key={index}>
                        {step === index + 2 && type === 'car' && losses.type !== 'object' ?
                            <>
                                <h4>{`${t('Car image')} ${t('Losses')} ${t(latinAlphabet[index])}`}</h4>
                                {losses.type !== 'object' &&  <div className='plate-container'>
                                    <ShowPlate plate={losses.car}/>
                                </div>}
                                <div className='gridParent' ref={form}>
                                    <ExpertImage
                                        title={`${t('Engraved chassis number')} ${t('Losses')} ${t(latinAlphabet[index])}`}
                                        src={attachments.filter(itm => itm.filename.includes(`losses_chassis_number${index + 1}`))}
                                        upload={(img, done) => finishUpload(img, `expert_losses_chassis_number${index + 1}`, done)}
                                        label='chassis_number'
                                        // required
                                    />
                                    <ExpertImage
                                        title={`${t('Front car')} ${t('Losses')} ${t(latinAlphabet[index])}`}
                                        src={attachments.filter(itm => itm.filename.includes(`losses_front_image${index + 1}`))}
                                        upload={(img, done) => finishUpload(img, `expert_losses_front_image${index + 1}`, done)}
                                        label='front_image'
                                        // required
                                    />
                                    <ExpertImage
                                        title={`${t('Back car')} ${t('Losses')} ${t(latinAlphabet[index])}`}
                                        src={attachments.filter(itm => itm.filename.includes(`losses_back_image${index + 1}`))}
                                        upload={(img, done) => finishUpload(img, `expert_losses_back_image${index + 1}`, done)}
                                        label='back_image'
                                        // required
                                    />
                                    <ExpertImage
                                        title={`${t('Left side car')} ${t('Losses')} ${t(latinAlphabet[index])}`}
                                        src={attachments.filter(itm => itm.filename.includes(`losses_left_image${index + 1}`))}
                                        upload={(img, done) => finishUpload(img, `expert_losses_left_image${index + 1}`, done)}
                                        label='left_image'
                                        // required
                                    />
                                    <ExpertImage
                                        title={`${t('Right side car')} ${t('Losses')} ${t(latinAlphabet[index])}`}
                                        src={attachments.filter(itm => itm.filename.includes(`losses_right_image${index + 1}`))}
                                        upload={(img, done) => finishUpload(img, `expert_losses_right_image${index + 1}`, done)}
                                        label='right_image'
                                        // required
                                    />
                                </div>
                                <div className='d-flex mt20 pr5 pl5'>
                                    <button
                                        onClick={() => stepHandler(step - 1, 'accessories')}
                                        className='btn btn-orange btn-block btn-circle-left'
                                    >
                                        {t('Prev step')}
                                    </button>
                                    <button
                                        onClick={changeStep}
                                        className='btn btn-white-purple btn-block btn-circle-right'
                                    >
                                        {t('Next step')}
                                    </button>
                                </div>
                            </>
                            :
                            <>
                            {
                               step === index + 2 && type === 'car' && losses.type === 'object' && setType('accessories')
                            }
                            </>
                        }
                        {
                            step === index + 2 && type === 'accessories' &&
                            <>
                                <Modal visible={imageUID}>
                                    <div className='image-modal'>
                                        <i className='fas fa-times'
                                            onClick={() => setImageUID(null)}
                                        />
                                        {/* <img src={`${url}/files?uid=${imageUID}`} alt='img' /> */}
                                        <ImageZoom imgUid={imageUID}/>
                                    </div>
                                </Modal>
                                <div className='gridParent'>
                                    <div className='crashGrid'>
                                        <h4> {`${t('Damaged positions and parts')} ${t('Losses')} ${t(latinAlphabet[index])}`}</h4>
                                        {losses.type !== 'object' && <div className='plate-container'>
                                            <ShowPlate plate={losses.car}/>
                                        </div>}
                                        <div className='crashGridChild'>
                                            {
                                                attachments
                                                    .filter(img => (img.filename.includes(`crash_image_los_x${index+1}x_`)))
                                                    .map((img) => (
                                                        <div className='imageBox' key={img.id}>
                                                            <img
                                                                src={`${url}/files?uid=${img.uid}&width=150&height=150`}
                                                                alt='img'
                                                                className='img'
                                                                onClick={() => setImageUID(img.uid)}
                                                            />
                                                        </div>
                                                    ))
                                            }
                                            {
                                                attachments
                                                    .filter(img => (img.filename.includes(`expert_crash_image_los_x${index+1}x_`)))
                                                    .map((img) => (
                                                        <div className='imageBox' key={img.id}>
                                                            <img
                                                                src={`${url}/files?uid=${img.uid}&width=150&height=150`}
                                                                alt='img'
                                                                className='img'
                                                                onClick={() => setImageUID(img.uid)}
                                                            />
                                                        </div>
                                                    ))
                                            }
                                            <div className='imageBox'>
                                                <ImagePickerModal
                                                    renderBtn={
                                                        <div className='add-image'><img src={addImage} alt='img'/></div>
                                                        // <div className='defaultImage' data-content={t('Add')}/>
                                                    }
                                                    disableGallery
                                                    upload={(img, done) => finishUpload(
                                                        img,
                                                        `expert_crash_image_los_x${index+1}x_${attachments.filter(img => img.filename.includes(`expert_crash_image_los_x${index+1}x_`)).length + 1}`,
                                                        done
                                                    )}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='d-flex mt20 pr5 pl5'>
                                    <button
                                        onClick={() => losses.type === 'object' ? stepHandler(step - 1, 'accessories') : setType('car')}
                                        className='btn btn-orange btn-block btn-circle-left'
                                    >
                                        {t('Prev step')}
                                    </button>
                                    <button
                                        onClick={() => lossesArray.length !== index + 1 ? stepHandler(step + 1, 'car') : NextStep()}
                                        className='btn btn-white-purple btn-block btn-circle-right'
                                    >
                                        {t('Next step')}
                                    </button>
                                </div>
                            </>
                        }
                    </div>

                ))
            }
        </div>
    );
}
